import { render, staticRenderFns } from "./RecommendedSpecialProduct25.vue?vue&type=template&id=364d6f8b&scoped=true&"
import script from "./RecommendedSpecialProduct25.vue?vue&type=script&lang=js&"
export * from "./RecommendedSpecialProduct25.vue?vue&type=script&lang=js&"
import style0 from "./RecommendedSpecialProduct25.vue?vue&type=style&index=0&id=364d6f8b&scoped=true&lang=css&"
import style1 from "./RecommendedSpecialProduct25.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364d6f8b",
  null
  
)

export default component.exports